// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TwodLive_updated-contaier__am0x- {
    margin: 0;
    font-size: 14px;
    color: var(--main-color);
    font-weight: 300;
    text-align: center;
    margin-bottom: 5px;
    -webkit-user-select: none;
            user-select: none;
}
.TwodLive_updated-contaier__am0x- > div {
    letter-spacing: .4px;
}
.TwodLive_live-number__sn6uN {
    text-align: center;
    -webkit-user-select: none;
            user-select: none;
    color: var(--main-color);
    font-size: 100px;
    font-weight: bolder;
    text-shadow: 0 4.36px 8.896px #353535, 0 -2px 1px #fff;
    margin-bottom: 10px;
}
.TwodLive_animation__\\+K9MX {
   animation: TwodLive_TextBlink__8a9ij 4s linear infinite;
}
.TwodLive_result-number__T847W {
    font-weight: bolder;
    color: var(--main-color);
    letter-spacing: .6px;
    margin-bottom: 0;
    font-size: 16px;
}
.TwodLive_result__3bQB5 {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;  
    color: #000;
    margin-top: 10px;
    font-size: 15px;
}
.TwodLive_result__3bQB5 div {
    text-align: center;
    font-weight: bolder;
    letter-spacing: .3px;
}

.TwodLive_result__3bQB5 p {
    margin-bottom: 0;
    font-weight: lighter;
    color: #000;
    letter-spacing: .3px;
}
.TwodLive_bets__x--tH {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    font-size: 17px;
}
@keyframes TwodLive_TextBlink__8a9ij {
    50% {
        opacity: 1;
    }
    57% {
        opacity: 0;
    }
    64% {
        opacity: 1;
    }
    71% {
        opacity: 0;
    }
    78% {
        opacity: 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/TwodLive.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,sDAAsD;IACtD,mBAAmB;AACvB;AACA;GACG,uDAAuC;AAC1C;AACA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".updated-contaier {\n    margin: 0;\n    font-size: 14px;\n    color: var(--main-color);\n    font-weight: 300;\n    text-align: center;\n    margin-bottom: 5px;\n    user-select: none;\n}\n.updated-contaier > div {\n    letter-spacing: .4px;\n}\n.live-number {\n    text-align: center;\n    user-select: none;\n    color: var(--main-color);\n    font-size: 100px;\n    font-weight: bolder;\n    text-shadow: 0 4.36px 8.896px #353535, 0 -2px 1px #fff;\n    margin-bottom: 10px;\n}\n.animation {\n   animation: TextBlink 4s linear infinite;\n}\n.result-number {\n    font-weight: bolder;\n    color: var(--main-color);\n    letter-spacing: .6px;\n    margin-bottom: 0;\n    font-size: 16px;\n}\n.result {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;  \n    color: #000;\n    margin-top: 10px;\n    font-size: 15px;\n}\n.result div {\n    text-align: center;\n    font-weight: bolder;\n    letter-spacing: .3px;\n}\n\n.result p {\n    margin-bottom: 0;\n    font-weight: lighter;\n    color: #000;\n    letter-spacing: .3px;\n}\n.bets {\n    position: fixed;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 17px;\n}\n@keyframes TextBlink {\n    50% {\n        opacity: 1;\n    }\n    57% {\n        opacity: 0;\n    }\n    64% {\n        opacity: 1;\n    }\n    71% {\n        opacity: 0;\n    }\n    78% {\n        opacity: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"updated-contaier": `TwodLive_updated-contaier__am0x-`,
	"live-number": `TwodLive_live-number__sn6uN`,
	"animation": `TwodLive_animation__+K9MX`,
	"TextBlink": `TwodLive_TextBlink__8a9ij`,
	"result-number": `TwodLive_result-number__T847W`,
	"result": `TwodLive_result__3bQB5`,
	"bets": `TwodLive_bets__x--tH`
};
export default ___CSS_LOADER_EXPORT___;
